import { Flex } from 'antd';

import { FiltersHandler } from './FiltersHandler';
import { Wrapper } from './QuizzesHeader.styles';

import { CreateQuiz } from '@/components/CreateQuiz';
import { QuizSearch } from '@/components/QuizSearch';

interface Props {
  isFromBaseContent?: boolean;
}

export const QuizzesHeader: React.FC<Props> = ({ isFromBaseContent }) => {
  return (
    <Wrapper>
      <Flex align="center" gap={16}>
        <QuizSearch />
        <FiltersHandler />
      </Flex>

      <CreateQuiz isFromBaseContent={isFromBaseContent} />
    </Wrapper>
  );
};
